import React from 'react';
import { Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { Redirect, Link, RouteComponentProps } from 'react-router-dom';
import { Row, Col, Alert, Button } from 'reactstrap';
import { Translate, getUrlParameter, translate } from 'react-jhipster';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import PasswordStrengthBar from 'app/shared/layout/password/password-strength-bar';
import { IRootState } from 'app/shared/reducers';
import { activateAction, reset } from './activate.reducer';
import { savePassword } from '../password-reg/password.reducer';
import { eIdLogin } from 'app/shared/reducers/authentication';
import { toast } from 'react-toastify';

const successAlert = (
  <Alert color="success">
    <Translate contentKey="activate.messages.success">
      <strong>Your user account has been activated.</strong> Please
    </Translate>
    <Link to="/reg/password" className="alert-link">
      <Translate contentKey="global.messages.info.authenticated.link">sign in</Translate>
    </Link>
  </Alert>
);

const failureAlert = (
  <Alert color="danger">
    <Translate contentKey="activate.messages.error">
      <strong>Your user could not be activated.</strong> Please use the registration form to sign up.
    </Translate>
  </Alert>
);

export interface IActivateProps extends StateProps, DispatchProps, RouteComponentProps<{ key: any }> {}

export interface IActivateState {
  password: string;
}

export class ActivatePage extends React.Component<IActivateProps, IActivateState> {
  state: IActivateState = {
    password: ''
  };
  componentWillUnmount() {
    this.props.reset();
  }

  componentDidMount() {
    const key = getUrlParameter('key', this.props.location.search);
    const id = getUrlParameter('id', this.props.location.search);
    this.props.activateAction(id, key);
  }

  componentDidUpdate() {
    const { activationSuccess } = this.props;
    if (activationSuccess) {
      toast.success(translate('activate.messages.success'), { autoClose: 6000 });
    }
  }

  handleValidSubmit = (event, values) => {
    const { account } = this.props;
    //savePassword(account.firstName, account.lastName, account.email, account.mobile, values.newPassword);
  };

  updatePassword = event => {
    this.setState({ password: event.target.value });
  };

  render() {
    const { activationSuccess, activationFailure, account } = this.props;
    if (activationSuccess) {
      return (
        <Redirect
          push
          to={{
            pathname: '/reg/password',
            state: { account: account }
          }}
        />
      );
    }
    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h1>
              <Translate contentKey="activate.title">Activation</Translate>
            </h1>
            {activationSuccess ? successAlert : undefined}
            {activationFailure ? failureAlert : undefined}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  activationSuccess: storeState.activate.activationSuccess,
  activationFailure: storeState.activate.activationFailure,
  account: storeState.activate.account
});

const mapDispatchToProps = { activateAction, reset, eIdLogin };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivatePage);
